module.exports = __webpack_public_path__ + "img/partner-promoplus.9aa127dc.webp";